import { useState, useEffect, MutableRefObject } from "react"
import { ChangeType } from "../api/EventTypes"

export type initialValType = { [key: string]: string }

const useFormValidation = (
  initialValue: initialValType,
  validate?: (initialstate: initialValType) => {},
  callback?: () => void,
  inputRef?: MutableRefObject<HTMLInputElement>
) => {
  const [values, setValues] = useState(initialValue)
  const [errors, setErrors] = useState(initialValue)
  const [touched, setTouched] = useState([])
  const [isSubmitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0
      if (noErrors) {
        setTouched([])
      }
      setSubmitting(false)
    }
  }, [errors, isSubmitting])

  useEffect(() => {
    if (validate) {
      const validationErrors = validate(values)
      const touchedErrors = Object.keys(validationErrors)
        .filter((key) => touched.includes(key)) // get all touched keys
        .reduce((acc, key) => {
          if (!acc[key]) {
            acc[key] = validationErrors[key]
          }
          return acc
        }, {})
      setErrors(touchedErrors)
    }
  }, [touched, validate, values])

  const handleBlur = (e: any) => {
    const { name } = e.target

    if (!touched.includes(name)) {
      setTouched([...touched, name])
    }
  }

  const handleLogoutUser = () => {
    setValues({
      ...values,
      password: ""
    })
  }
  const handleUnlockCode = () => {
    setValues({
      ...values,
      password: "",
      unlockCode: "",
      first: "",
      second: ""
    })
  }

  const handleChange = (e: ChangeType) => {
    const { value, name, maxLength } = e.target

    if (maxLength === value.length) {
      inputRef.current.focus()
      inputRef.current.select()
    }

    setValues({
      ...values,
      [name]: value
    })
  }

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const validationErrors = validate(values)
    setErrors(validationErrors)
    setSubmitting(true)
    callback && callback()
  }
  return {
    handleChange,
    values,
    errors,
    handleBlur,
    handleSubmit,
    handleLogoutUser,
    handleUnlockCode
  }
}
export default useFormValidation
